import React from "react";
import { Grid2 as Grid, Grid2Props } from "@mui/material";
import { singleGridItem } from "../forms/fields/defaultStyles";

const GroupGridContainer: React.FC<Grid2Props> = ({ children, ...props }) => {
  return (
    <Grid
      container
      spacing={2}
      {...singleGridItem}
      {...props}
      sx={{
        borderRadius: 4,
        border: 1,
        borderColor: "divider",
        p: 2,
        ...props.sx,
      }}
    >
      {children}
    </Grid>
  );
};

export default GroupGridContainer;
